"use client";

import { useEffect, useState } from "react";

const scheduleIdle = (callback, timeout = 1200) => {
  if (typeof window === "undefined") return null;

  if (typeof window.requestIdleCallback === "function") {
    return window.requestIdleCallback(callback, { timeout });
  }

  return window.setTimeout(callback, timeout);
};

const cancelIdle = (handle) => {
  if (typeof window === "undefined" || handle === null) return;

  if (typeof window.cancelIdleCallback === "function") {
    window.cancelIdleCallback(handle);
    return;
  }

  window.clearTimeout(handle);
};

export function IdleMount({ children, fallback = null, timeout = 1200 }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const handle = scheduleIdle(() => {
      if (!cancelled) {
        setMounted(true);
      }
    }, timeout);

    return () => {
      cancelled = true;
      cancelIdle(handle);
    };
  }, [timeout]);

  if (!mounted) return fallback;

  return children;
}
